module.exports = __webpack_public_path__ + "static/media/Synopsis - Passing the Faith onto Loved Ones.c6c813a0.docx";